import React, { useState } from "react";
import api from "../../utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

export default function Login({ setLoggedIn }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState(1);
  const [show, setShow] = useState(false);
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("/auth/login", { email, password });
      toast.info("OTP sent to your email");
      setUserId(res.data.userId);
      setUserName(res.data.userName);

      setStep(2);
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post("auth/verify-mfa", { userId, otp });
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", userName);
      setLoggedIn(res.data.token);
      toast.success("Login successful");
      navigate("/dashboard");
    } catch (err) {
      toast.error("Invalid OTP");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 400 }}>
      <h2>Login</h2>
      {step === 1 && (
        <>
          <form onSubmit={handleLogin}>
            <input
              className="form-control my-2"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className="d-flex align-items-center gap-2">
              <input
                type={show ? "text" : "password"}
                className="form-control my-2"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
              {show ? (
                <FaEye onClick={() => setShow((prev) => !prev)} />
              ) : (
                <FaEyeSlash onClick={() => setShow((prev) => !prev)} />
              )}
            </div>
            <button className="btn btn-primary">Send OTP</button>
          </form>
          <p className="mt-3 text-center">
            Do not have an account? <a href="/register">Register</a>
          </p>
        </>
      )}
      {step === 2 && (
        <form onSubmit={handleVerifyOtp}>
          <input
            className="form-control my-2"
            placeholder="Enter OTP"
            onChange={(e) => setOtp(e.target.value)}
          />
          <button className="btn btn-success">Verify OTP</button>
        </form>
      )}
    </div>
  );
}
